export default __webpack_public_path__ + "static/media/stoyan_xl.7b0eba6f.jpg";